/* eslint-disable no-unused-vars */
import React from "react"
import { Routes as ReactRoutes, Route } from "react-router-dom"
import WithLayout from "WithLayout"
// Available layouts
import { Main as MainLayout } from "./layouts"

// Landing pages
import { DesignAgency as DesignAgencyView } from "./views/landingPages"

// Supporting pages
import {
    About as AboutView,
    Contact as ContactView,
    NotFound as NotFoundView,
} from "./views/supportingPages"

// Admin pages
import Login from "./views/admin/Login"
import Dashboard from "./views/admin/Dashboard"
import ProtectedRoute from "./components/ProtectedRoute"

const Routes = () => {
    return (
        <ReactRoutes>
            <Route
                exact
                path="/"
                element={((matchProps) => (
                    <WithLayout
                        {...matchProps}
                        component={DesignAgencyView}
                        layout={MainLayout}
                    />
                ))()}
            />
            <Route
                exact
                path="/landing-design-agency"
                element={((matchProps) => (
                    <WithLayout
                        {...matchProps}
                        component={DesignAgencyView}
                        layout={MainLayout}
                    />
                ))()}
            />
            <Route
                exact
                path="/page-about"
                element={((matchProps) => (
                    <WithLayout
                        {...matchProps}
                        component={AboutView}
                        layout={MainLayout}
                    />
                ))()}
            />

            <Route
                exact
                path="/page-contact"
                element={((matchProps) => (
                    <WithLayout
                        {...matchProps}
                        component={ContactView}
                        layout={MainLayout}
                    />
                ))()}
            />
            <Route
                exact
                path="/admin/login"
                element={<Login />}
            />
            <Route
                exact
                path="/admin"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="*"
                element={((matchProps) => (
                    <WithLayout
                        {...matchProps}
                        component={NotFoundView}
                        layout={MainLayout}
                    />
                ))()}
            />
        </ReactRoutes>
    )
}

export default Routes
